export default "__VITE_ASSET__f046fea2__"